import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { PhotoFaceInfo } from "./photoFaceSlice";

export interface FaceSetSomebodyState {
  state: LoadStateInfo;
  request?: SetFaceSomebodyRequest;
}

const initialState: FaceSetSomebodyState = {
  state: notStarted(),
};

export interface SetFaceSomebodyRequest {
  face: PhotoFaceInfo;
  target: "student" | "user";
  targetId: string;
}

export const requestSetFaceSomebody = createAsyncThunk(
  "requestSetFaceSomebody",
  async (param: SetFaceSomebodyRequest, thunkAPI) => {
    console.debug("requestSetFaceSomebody");

    const response = await fetch(`${getBackendUrl()}/api/face/${param.face.id}/${param.target}/${param.targetId}`, {
      method: "POST",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });

    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);


export const faceSetSomebodySlice = createSlice({
  name: "faceSetSomebody",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clean: (state) => {
      state.state = notStarted();
      state.request = undefined;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(requestSetFaceSomebody.pending, (state, /* action */) => {
        state.state =  loading();
      })
      .addCase(requestSetFaceSomebody.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
      })
      .addCase(requestSetFaceSomebody.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

// export const { } = faceSetSomebody.actions;

export const selectFaceSetSomebody = (state: RootState) => state.faceSetSomebody;

export default faceSetSomebodySlice.reducer;
